import { OrderState } from "../miscellaneous/orderAtom";
import { fetchGetCarts } from "./fetchGetCarts";
import { RequestOrderOutput } from "./requestOrder";

export async function requestCarts(
  order: OrderState
): Promise<RequestOrderOutput> {
  const carts = await fetchGetCarts();
  return {
    tag: carts.tag,
    order:
      carts.tag === "successful"
        ? {
            ...(order === "initializing" ? {} : order),
            ...carts.parsed,
          }
        : order,
  };
}
